<!--  -->
<template>
  <!--  -->
  <div class="prview_box">
    <div>
      <div class="phoner_box">
        <div class="all_boxr">
          <div class="content_box" />
          <div
            v-for="item,index in attachments"
            :key="index"
            class="at_box"
          >
            <!-- <div class="onebox">
              <img :src="item.cover_path" style="width:80px;height:80px;margin:10px 0px 0px 23px">
            </div>
            <div class="onebox">
              <div class="within_box">
                <div class="title_boxr">{{ item.alias_name }}</div>
                <div class="imaetext se_top">
                  <div class="describe_text">{{ item.name }}</div>
                  <div>11
                    <img v-if="item.link.picurl" style="width:50px;height:50px;object-fit: contain;" :src="item.link.picurl">
                  </div>
                </div>
              </div>
            </div> -->
            <div class="onebox">
              <div>
                <div class="mincard">
                  <div
                    class="mincard_title"
                    style="display: flex;align-items: center;"
                  >
                    <img
                      :src="item.cover_path"
                      style="width: 50px;"
                      alt=""
                      srcset=""
                    >
                    <!-- <div
                      class="mincard_title"
                      style="margin-bottom: 0px;margin-left:5px"
                    >{{ item.alias_name }}</div> -->
                  </div>
                  <div class="mincard_enjoy">{{ item.name }}</div>
                  <div>
                    <!-- <img :src="item.miniprogram.thumburl" class="imgrbox"> -->
                    <!-- <video :src="item.video_path" class="imgrbox" /> -->
                    <!-- <video
                      ref="videoPlayer"
                      style="height: 180px; width: 190px;"
                      :src="item.video_path"
                      controls
                      @click="playVideo"
                    /> -->
                    <!-- 222 -->
                    <div
                      v-if="item.article_url_type === 1"
                      v-html="item.content"
                      style="overflow: auto;height: 160px;"
                    ></div>
                    <div v-if="item.article_url_type === 2">
                      <a
                        :href="item.content"
                        target="_blank"
                      >点击跳转预览</a>
                    </div>
                  </div>
                  <!-- <div class="line" /> -->
                  <!-- <div class="bottomwr">
                    <img src="https://cdn.mdxcx.net/default/20210625/33695da2774d54929387886410828920.png%21watermark" alt="" style="width:28px;height:28px">
                    <div class="weadar">小程序</div>
                  </div> -->
                </div>
              </div>
            </div>
            <!-- <div v-if="item.msgtype === 'sp_miniprogram'" class="onebox">
              <div v-if="item.msgtype === 'sp_miniprogram' && item.sp_miniprogram && item.sp_miniprogram.title!=='' && item.sp_miniprogram.title!==null">
                <div class="mincard">
                  <div style="display: flex;align-items: center;"><img :src="item.sp_miniprogram.weappiconurl" style="width: 25px;" alt="" srcset=""><div class="mincard_title" style="margin-bottom: 0px;margin-left:5px">{{ item.sp_miniprogram.des_1 }}</div></div>
                  <div class="mincard_enjoy">{{ item.sp_miniprogram.title }}</div>
                  <div>
                    <img v-if="item.msgtype === 'sp_miniprogram' && item.sp_miniprogram && item.sp_miniprogram.thumburl!=='' && item.sp_miniprogram.thumburl!==null" :src="item.sp_miniprogram.thumburl" class="imgrbox">
                  </div>
                  <div class="line" />
                  <div class="bottomwr">
                    <img src="https://cdn.mdxcx.net/default/20210625/33695da2774d54929387886410828920.png%21watermark" alt="" style="width:28px;height:28px">
                    <div class="weadar">小程序</div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mptypeslist, customerMessagepush } from '@/api/sourceMaterial.js'
export default {
  data() {
    return {
      attachments: [],
      programtype: [],
      title: '',
      content: '',
      type: null,
      dialogVisible: false,
      customdialogVisible: false,
      obj: {},
      employee_no: null,
      external_user_id: null,
      employee_name: '',
      external_name: '',
      adlist: [],
      detailList: [],
      contenttitle: '',
      currentIndex: 0,
      show: 8,
      isshow: 0,
      isFunctionExecuting: false
    }
  },
  created() {},
  async mounted() {},
  methods: {
    async send(item, type) {
      console.log('item:', item)
      this.title = item.title
      this.obj = item
      this.type = type
      // if (item.content === null) {
      //   this.content = ''
      // } else {
      //   this.content = item.content.replace(/\n/g, '<br>')
      // }
      this.attachments = []
      this.attachments.push(item)
      // this.getmptypeslist()
    },
    // 获取小程序消息类型
    async getmptypeslist() {
      const data = await mptypeslist()
      this.programtype = data.data.types
    },
    find(id) {
      console.log('id', id)
      const indexs = this.programtype.findIndex(item => {
        // eslint-disable-next-line eqeqeq
        return item.mini_program_type == id
      })
      if (indexs === -1) {
        return ''
      } else {
        return this.programtype[indexs].type_name
      }
    },
    async sumbit() {
      console.log('this.obj', this.obj.sp_message_no, this.obj.push_method, this.employee_no, this.external_user_id)
      // eslint-disable-next-line eqeqeq
      if (this.employee_no == null || this.employee_no == '') {
        this.$message.error('请选择员工')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.external_user_id == null || this.external_user_id == '') {
        this.$message.error('请选择员工客户')
        return
      }

      const data = await customerMessagepush({
        sp_message_no: this.obj.sp_message_no,
        push_method: this.obj.push_method,
        employee_no: this.employee_no,
        external_user_id: this.external_user_id
      })
      this.$message({
        type: 'success',
        message: '操作成功!'
      })
      this.updata()
      console.log('data', data)
    },
    choosestaff() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.choosestaffview.send(this.obj)
      })
    },
    staffcallback(item) {
      this.dialogVisible = false
      this.external_user_id = null
      this.external_name = ''
      this.employee_no = item.employee_no
      this.employee_name = item.name
      console.log('item', item)
    },
    choosecustom() {
      this.customdialogVisible = true
      this.$nextTick(() => {
        this.$refs.choosecustomview.customsend(this.employee_no)
      })
    },
    playVideo() {
      const videoPlayer = this.$refs.videoPlayer
      if (videoPlayer.paused) {
        videoPlayer.play()
      } else {
        videoPlayer.pause()
      }
    },
    customcallback(item) {
      this.customdialogVisible = false
      this.external_user_id = item.external_user_id
      this.external_name = item.remark
      console.log('item', item)
    },
    updata() {
      this.employee_no = null
      this.employee_name = ''
      this.external_user_id = null
      this.external_name = ''
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.within_box {
  width: 190px;
  border: 1px solid #19be6b;
  height: 100%;
  padding: 8px 8px 8px 7px;
  margin-left: 23px;
  margin-top: 15px;
}
.title_boxr {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 157px;
}
.imaetext {
  display: flex;
  justify-content: space-between;
}
.se_top {
  margin-top: 14px;
}
.describe_text {
  color: #999999;
  width: 136px;
  overflow: hidden;
  -webkit-line-clamp: 3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  height: 50px;
}
.mincard {
  width: 215px;
  height: 251px;
  border: 1px solid #ccc;
  padding: 10px;
  box-sizing: border-box;
  margin: 10px 0px 0px 23px;
}
.mincard_title {
  font-size: 12px;
  margin-bottom: 5px;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.imgrbox {
  width: 100%;
  height: 150px;
}
.line {
  width: 100%;
  height: 1px;
  background: #999999;
  /* margin: 5px 0px; */
  margin: 3px 0px;
}
.bottomwr {
  display: flex;
  align-items: center;
}
.mincard_enjoy {
  margin-bottom: 5px;
  width: 134px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.weadar {
  margin-left: 2px;
  font-size: 12px;
}
.all_box {
  margin: 8px 0px;
  max-height: 500px;
  overflow: hidden;
  overflow-y: auto;
  width: 100%;
}
.onebox {
  display: flex;
  align-items: center;
}
.swr {
  width: 50px;
  text-align: right;
}
.prview_box {
  /* max-height: 500px;
  overflow: hidden;
  overflow-y: scroll; */
  display: flex;
}
.prview_box::-webkit-scrollbar {
  width: 0;
}
.box_serw {
  color: rgb(169, 162, 151);
  font-size: 14px;
}
.phoner_box {
  background: url(../../../assets/larke/iphone6.395625b9.jpg) no-repeat;
  background-size: 100% 100%;
  width: 300px;
  height: 600px;
  margin: 0 auto;
  position: relative;
}
.phoner_boxone {
  background: url(../../../assets/larke/iphone6.395625b9.jpg) no-repeat;
  background-size: 100% 100%;
  width: 300px;
  height: 600px;
  position: relative;
}
.at_box {
  margin: 10px 0px;
}
.all_boxr {
  max-height: 365px;
  overflow-y: auto;
  position: absolute;
  top: 120px;
  padding-left: 20px;
  box-sizing: border-box;
  width: 92%;
}
::-webkit-scrollbar {
  width: 10px;
  height: 1px;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #ccc;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 5px;
}
.content_box {
  padding: 20px;
}
.form_box {
  margin-left: 60px;
}
.send_message {
  text-align: center;
  width: 360px;
  font-size: 18px;
  margin-bottom: 30px;
}
.tybox {
  display: flex;
}
</style>
